import { AdminAvatar } from "@/components/admin/avatar";
import { Card, CardHead } from "@/components/admin/card";
import { AdminIcon } from "@/components/admin/icon";
import {
	useFailedAttempts,
	useGlobalSessions,
	useRevokeGlobalSession,
} from "@/hooks/use-admin-l4";

export function SecurityTab() {
	const { data: sessions } = useGlobalSessions();
	const { data: failed } = useFailedAttempts();
	const revokeMutation = useRevokeGlobalSession();

	return (
		<div className="stack">
			<Card>
				<CardHead
					title={`Sessions actives globales · ${sessions?.length ?? 0}`}
					sub="Toutes les sessions ouvertes sur le système (CDC §18.5)"
				/>
				<div className="table-wrap" style={{ margin: 0 }}>
					<table className="table">
						<thead>
							<tr>
								<th>Utilisateur</th>
								<th>Appareil</th>
								<th>IP</th>
								<th>Dernière activité</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{(!sessions || sessions.length === 0) && (
								<tr>
									<td colSpan={5} className="muted center">
										Aucune session active.
									</td>
								</tr>
							)}
							{sessions?.map((s) => (
								<tr key={s.id} data-testid={`global-session-row`}>
									<td>
										<div
											style={{ display: "flex", alignItems: "center", gap: 8 }}
										>
											<AdminAvatar name={s.user.fullName} />
											<div>
												<strong style={{ fontSize: 12 }}>
													{s.user.fullName}
												</strong>
												<div className="mono muted" style={{ fontSize: 11 }}>
													{s.user.email}
												</div>
											</div>
										</div>
									</td>
									<td>
										<strong style={{ fontSize: 11 }}>
											{shortenUa(s.userAgent)}
										</strong>
										<div className="mono muted" style={{ fontSize: 10 }}>
											{s.id.slice(0, 8)}
										</div>
									</td>
									<td className="mono" style={{ fontSize: 11 }}>
										{s.ip ?? "—"}
									</td>
									<td className="muted" style={{ fontSize: 11 }}>
										{new Date(s.lastActivityAt).toLocaleString("fr-FR")}
									</td>
									<td>
										<button
											className="top-btn"
											title="Révoquer"
											onClick={() => revokeMutation.mutate(s.id)}
											data-testid={`global-session-revoke-${s.id}`}
										>
											<AdminIcon n="close" s={14} c="var(--a-danger)" />
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</Card>

			<Card>
				<CardHead
					title="Tentatives de connexion échouées"
					sub="50 dernières · rate-limited 5/15min par compte"
				/>
				<div className="table-wrap" style={{ margin: 0 }}>
					<table className="table">
						<thead>
							<tr>
								<th>Identifiant</th>
								<th>IP</th>
								<th>Quand</th>
							</tr>
						</thead>
						<tbody>
							{(!failed || failed.length === 0) && (
								<tr>
									<td colSpan={3} className="muted center">
										Aucune tentative échouée enregistrée.
									</td>
								</tr>
							)}
							{failed?.map((f) => (
								<tr key={f.id}>
									<td className="mono">{f.identifier}</td>
									<td className="mono">{f.ip ?? "—"}</td>
									<td className="muted">
										{new Date(f.attemptedAt).toLocaleString("fr-FR")}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</Card>
		</div>
	);
}

function shortenUa(ua: string | null): string {
	if (!ua) return "Inconnu";
	if (ua.includes("Chrome")) return "Chrome";
	if (ua.includes("Firefox")) return "Firefox";
	if (ua.includes("Safari")) return "Safari";
	if (ua.startsWith("curl")) return "curl";
	return ua.slice(0, 30);
}
